import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      <Link to="/" className="flex items-center gap-1 transition-colors hover:text-accent-400">
        <i className="ri-home-4-line text-sm" />
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-sm text-foreground-700" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-accent-400">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-300">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}